import React, { Component } from 'react';
import './HomePage.sass';
import '../Loader/LoaderV2.sass';
import PropTypes from 'prop-types'
import LocationActions from '../../actionCreators/LocationActions';
import isEmpty from 'lodash/isEmpty'
import find from 'lodash/find';
import get from 'lodash/get';
import reduce from 'lodash/reduce';
import { connect } from 'react-redux';
import DeliveryOnlyContent from './DeliveryOnly/DeliveryOnlyContent';
import DeliveryOnlyHeader from './DeliveryOnly/DeliveryOnlyHeader';
import OutOfRangeModal from './modals/OutOfRangeModal';
import DeliveryModal from './modals/DeliveryModal';
import VideoModal from './modals/VideoModal';
import qs from 'querystringify';
import analyticsManifest from '../../analytics/analyticsManifest';
import UIActions from '../../actionCreators/UIActions';
import cookieUtils from '../../utils/cookieUtils';
import { LOCATION_SUBDOMAIN_COOKIE } from '../../constants/sharedKeys';
import TREATMENTS from '../../constants/Treatments';
import { menuUrl } from '../../utils/urlUtils';
import { isWithinPickupPolygon } from '../../utils/placesUtils';
import Footer from '../Footer/Footer'

export class HomePage extends Component {

  static propTypes = {
    kitchens: PropTypes.array
  }

  constructor() {
    super()
    this.state = {
      displayErrorModal: false,
      displayDeliveryModal: false,
      displayVideoModal: false,
      initialModalShown: false,
      videoSrc: null,
      address: null,
      hasTimedOut: false,
    }
    this.renderHeader = this.renderHeader.bind(this);
    this.onAddressChange = this.onAddressChange.bind(this);
  }

  componentDidMount() {
    const {
      isAuthenticated,
      location,
      kitchensLoad,
      delivery_address,
      savedAddressesLoad,
      location: { pathname },
      setTreatmentOverride
    } = this.props;

    kitchensLoad();

    document.body.classList.add('homepage')
    if (delivery_address) {
      this.onAddressChange(delivery_address, false)
    }
    const searchParams = qs.parse(get(location, 'search'));
    if(isAuthenticated) {
      savedAddressesLoad();
    }

    const currSubdomain = window.location.host.split('.')[0];
    const lastSubdomain = cookieUtils.getCookie(LOCATION_SUBDOMAIN_COOKIE);
    if (
      (currSubdomain === 'www' || currSubdomain === 'localhost')
      && !isEmpty(lastSubdomain)
      && (pathname.indexOf('/locations') === -1)
      ) { // Localhost for unit tests
      const url = menuUrl(`${lastSubdomain}.${window.ENV.ENV_DOMAIN}`);
      window.location.replace(`${url}ar=true`);
    }
    this.timeout = setTimeout( () => {
      this.setState({ hasTimedOut: true });
    }, 3000);

    TREATMENTS.map((key) => {
      const value = get(searchParams, key);
      if (value) {
        setTreatmentOverride({ [key]: value });
      }
      return undefined;
    });
  }

  componentDidUpdate() {
    const {
      match: { params: { locationId = 'downtown-indy' } },
      location: { pathname },
      kitchens,
    } = this.props;
    const { initialModalShown } = this.state;
    const selectedKitchen = find(kitchens, { slug: locationId });
    const showDeliveryModal = !initialModalShown &&
      (pathname.indexOf('/locations') !== -1) && selectedKitchen;

    if (showDeliveryModal) {
      this.setState(
        () => ({ initialModalShown: true, selectedKitchen }),
        () => (this.toggleDeliveryModal())
      );
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
    document.body.classList.remove('homepage')
  }

  onAddressChange(addrInfo, redirect = true) {
    const { address } = this.state;
    const { enhancedTrack } = this.props;
    if(addrInfo && addrInfo.location) {
      if (addrInfo.address) {
        this.setState({address: addrInfo.address});
      }

      this.props.locationChange(
        addrInfo.location,
        addrInfo.address,
        addrInfo.address_components,
        addrInfo.type
      )
      .then((kitchen) => {
        const payload = get(kitchen, 'action.payload');
        const addressChangeSuccess = get(analyticsManifest, 'customEvents.addressChangeSuccess');
        enhancedTrack(addressChangeSuccess('Home'));
        this.setState(
          {
            kitchen: payload,
            deliveryAddress: addrInfo,
            inRange: true,
            displayErrorModal: false
          },
          () => {
            if (redirect && addrInfo.type) {
              const addressChangeRedirect = get(analyticsManifest, 'customEvents.addressChangeRedirect');
              enhancedTrack(addressChangeRedirect(addrInfo.type));

              const forcePickup = isWithinPickupPolygon(addrInfo, payload)
              const kitchenUrl = menuUrl(payload.subdomain, forcePickup ? {} : addrInfo, forcePickup);
              window.location.replace(kitchenUrl)
            }
          }
        );
      })
      .catch((e) => {
        const addressChangeError = get(analyticsManifest, 'customEvents.addressChangeError');
        const displayErrorModal = addrInfo.address !== address ? true : false;

        enhancedTrack(addressChangeError('Home'));
        this.setState({
          deliveryAddress: null,
          kitchen: null,
          inRange: false,
          displayErrorModal
        });
      })
    } else if (addrInfo === null) {
      const nextState = {
        deliveryAddress: null,
        kitchen: null,
        inRange: false,
        displayErrorModal: false
      };
      this.setState(nextState);
    }
  }

  toggleDeliveryModal() {
    const { kitchens, kitchensLoad } = this.props
    if (isEmpty(kitchens)) {
      kitchensLoad();
    }

    const selectedKitchen = this.state.selectedKitchen || kitchens[0]
    this.setState({
      displayErrorModal: false,
      selectedKitchen,
      displayDeliveryModal: !this.state.displayDeliveryModal,
    })
  }

  selectKitchen(kitchen) {
    this.setState({
      selectedKitchen: kitchen
    })
  }

  toggleVideoModal(e, videoSrc = 'https://www.youtube.com/embed/-03fZZninms') {
    e.preventDefault()
    this.setState({
      videoSrc,
      displayErrorModal: false,
      displayDeliveryModal: false,
      displayVideoModal: !this.state.displayVideoModal
    })
  }

  renderHeader() {
    const {
      delivery_address,
      savedAddresses,
      enhancedTrack,
      lessThan,
    } = this.props;

    const {
      kitchen,
      inRange,
    } = this.state;

    let kitchenUrl
    if (kitchen) {
      const forcePickup = isWithinPickupPolygon(delivery_address, kitchen)
      kitchenUrl = menuUrl(kitchen.subdomain, forcePickup ? {} : this.state.deliveryAddress, forcePickup)
    }
    return (
      <DeliveryOnlyHeader {...{
        kitchenUrl,
        inRange,
        savedAddresses,
        enhancedTrack,
        lessThan
      }}
      deliveryAddress={delivery_address}
      onAddressChange={this.onAddressChange}
      onToggleDeliveryModal={this.toggleDeliveryModal.bind(this)}/>
    );
  }

  render() {
    const { kitchens } = this.props;
    const {
      displayDeliveryModal,
      displayErrorModal,
      selectedKitchen,
      displayVideoModal,
      videoSrc,
    } = this.state;

    const kitchenMap = reduce(
      kitchens,
      (sum, val, key) => {
        sum[val.id] = val;
        return sum
      },
      {}
    );

    const videoModal = displayVideoModal ?
    <VideoModal
      {...{videoSrc}}
      onRequestHide={this.toggleVideoModal.bind(this)}/> :
    null;

    const outOfRangeModal = displayErrorModal ?
    <OutOfRangeModal
      onToggleDeliveryModal={this.toggleDeliveryModal.bind(this)}
      onRequestHide={() => this.setState({ displayErrorModal: false })}/> :
    null;

    const deliveryModal = !displayDeliveryModal || !selectedKitchen ?
    null :
    <DeliveryModal
      {...{kitchens}}
      menuLink={menuUrl(selectedKitchen.subdomain)}
      selectedKitchen={selectedKitchen || kitchens[0]}
      onClick={this.selectKitchen.bind(this)}
      onSelect={(e) => {
        this.setState({ selectedKitchen: kitchenMap[e.target.value] });
      }}
      onRequestHide={this.toggleDeliveryModal.bind(this)}/>;

    return (
        <div className='homepage default-homepage'>
            {outOfRangeModal}
            {deliveryModal}
            {videoModal}
            {this.renderHeader()}
            <DeliveryOnlyContent onVideoLaunch={this.toggleVideoModal.bind(this)}/>
            <Footer />
        </div>
    )
  }
}

export default connect(
  (state) => ({
    isAuthenticated: get(state.userReducer, 'isAuthenticated', false),
    kitchens: get(state.locationReducer, 'kitchens'),
    delivery_address: get(state.locationReducer, 'delivery_address'),
    savedAddresses: get(state.locationReducer, 'savedAddresses', {}),
    treatments: get(state.treatmentReducer, 'treatments', {}),
    lessThan: get(state.browser, 'lessThan', {}),
   }),
  {
    savedAddressesLoad: LocationActions.savedAddressesLoad,
    locationChange: LocationActions.locationChange,
    kitchensLoad: LocationActions.kitchensLoad,
    enhancedTrack: UIActions.enhancedTrack,
    setTreatmentOverride: UIActions.setTreatmentOverride,
    setPickup: LocationActions.setPickup,
  }
)(HomePage);
